import { MakeCollectionPrivateModalStore } from "@/components/modal/make-collection-private/make-collection-private-modal-store";
import {
  MDSButton,
  MDSButtonGroup,
  MDSButtonVariant,
  MDSDialogSlotName,
  MDSDialogTextContent,
  MDSModalDialog,
  MDSText,
  MDSTextVariant,
} from "@/mds";
import { inflect } from "inflection";
import { observer } from "mobx-react-lite";
import { useMemo } from "react";

export const MakeCollectionPrivateModal = observer<{
  store: MakeCollectionPrivateModalStore;
}>(({ store }) => {
  const collaboratorText = useMemo(() => {
    const numCollaborators = store.collection?.sharedWithLabels.length;
    if (!numCollaborators) return "";
    return `, which will remove ${numCollaborators} ${inflect("collaborator", numCollaborators)} currently sharing this collection`;
  }, [store.collection?.sharedWithLabels.length]);

  return (
    <MDSModalDialog isOpen={store.isOpen} handleClose={() => store.close()}>
      <MDSText slot={MDSDialogSlotName.Header} variant={MDSTextVariant.HeaderL}>
        Make this collection private?
      </MDSText>

      <MDSDialogTextContent slot={MDSDialogSlotName.Content}>
        <MDSText variant={MDSTextVariant.ParagraphS}>
          You are about to make this collection private{collaboratorText}. This action will make the
          collection visible only to you and may result in losing access to some notes not
          individually shared with you.
        </MDSText>
      </MDSDialogTextContent>

      <MDSButtonGroup slot={MDSDialogSlotName.ButtonsRight}>
        <MDSButton onClick={() => store.close()}>Cancel</MDSButton>
        <MDSButton
          variant={MDSButtonVariant.DangerFilled}
          onClick={async () => await store.handleSubmit()}
        >
          Make private
        </MDSButton>
      </MDSButtonGroup>
    </MDSModalDialog>
  );
});
